import type { ReactNode } from 'react';

export const symbol_battery_android_frame_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h620q37.5 0 63.75 26.25T840-630v300q0 37.5-26.25 63.75T750-240H130Zm0-60h620q12.75 0 21.38-8.63Q780-317.25 780-330v-300q0-12.75-8.62-21.38Q762.75-660 750-660H130q-12.75 0-21.37 8.62Q100-642.75 100-630v300q0 12.75 8.63 21.37Q117.25-300 130-300Zm740-87v-186h20q12 0 21 9t9 21v126q0 12-9 21t-21 9h-20Zm-740 27v-240q0-12.75 8.63-21.38Q147.25-630 160-630h320q12.75 0 21.38 8.62Q510-612.75 510-600v240q0 12.75-8.62 21.37Q492.75-330 480-330H160q-12.75 0-21.37-8.63Q130-347.25 130-360Z"
		/>
	</svg>
);
